// extracted by mini-css-extract-plugin
export default {"chat_input":"_1cprdWBS8et_FyPdhq6zmN","chat_input_field":"_2OJEnIJpED-BAxZ7f3GVmW","chat_send_button":"_1w-kFt5G8BRLrhHFTsXKM1","only_chat":"MqlCmIuc8jDnw4h9NQjED"};